import {constants} from '../../constants';

// A counter, not a boolean: with several requests in flight the first one to
// finish must not dismiss the spinner for the rest. setLoading(true) increments
// and setLoading(false) decrements, so consumers keep reading it as truthy
// until every request has finished. Every existing consumer tests truthiness,
// and 0 is falsy, so nothing else had to change.
const loadingReducer = (state = 0, action) => {
    switch (action.type) {
        case constants.IS_LOADING:
            return action.payload ? state + 1 : Math.max(0, state - 1);
        default:
            return state;
    }
}
export default loadingReducer
